import { Reveal } from "./Reveal";
import { IMAGES } from "../data/content";

export const About = () => (
  <section id="rreth-nesh" data-testid="about-section" className="overflow-hidden bg-bone py-24 text-ink sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-16 px-5 sm:px-8 lg:grid-cols-2 lg:gap-12">
      <div className="flex flex-col justify-center lg:pr-10">
        <Reveal>
          <p className="eyebrow mb-5">Rreth nesh</p>
          <h2 data-testid="about-title" className="font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Mbi 30 vite përvojë në metal
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p data-testid="about-text-1" className="mt-8 text-base leading-relaxed text-ink/70 sm:text-lg">
            ALBESI AXH METAL është kompani e specializuar në përpunimin dhe realizimin e punimeve metalike, me lokacion në Çellopek të Tetovës dhe me mbi 30 vite përvojë pune në këtë fushë.
          </p>
          <p data-testid="about-text-2" className="mt-5 text-base leading-relaxed text-ink/70 sm:text-lg">
            Për më shumë se tri dekada, përkushtimi ynë ndaj cilësisë, precizionit dhe qëndrueshmërisë na ka bërë një partner të besueshëm për projekte të ndryshme, nga punimet individuale deri te konstruksionet metalike me përmasa të mëdha.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-10 flex items-center gap-5 border-t hairline-light pt-8" data-testid="about-facts">
            <p className="font-display text-sm font-bold uppercase tracking-[0.2em]">Çellopek – Tetovë</p>
            <span className="h-4 w-px bg-ink/20" />
            <p className="text-sm text-ink/55">Mbi 30 vite përvojë pune</p>
          </div>
        </Reveal>
      </div>

      <div className="relative pb-14 sm:pb-20">
        <Reveal className="relative z-10">
          <img
            src={IMAGES.stadium}
            alt="Rrethim metalik stadiumi i realizuar nga ALBESI AXH METAL"
            data-testid="about-image-main"
            className="aspect-[16/11] w-full object-cover shadow-2xl"
          />
        </Reveal>
        <Reveal delay={0.15} className="absolute -bottom-4 left-0 z-20 w-[44%] border-8 border-bone sm:-bottom-10">
          <img
            src={IMAGES.stairs}
            alt="Parmak metalik me prerje gjeometrike"
            data-testid="about-image-secondary"
            className="aspect-[3/4] w-full object-cover shadow-xl"
          />
        </Reveal>
        <Reveal delay={0.3} className="absolute -bottom-10 right-0 z-20 hidden w-[34%] border-8 border-bone sm:-bottom-14 sm:block">
          <img
            src={IMAGES.carportDrive}
            alt="Mbulesë metalike për oborr dhe garazh"
            data-testid="about-image-third"
            className="aspect-square w-full object-cover shadow-xl"
          />
        </Reveal>
        <div className="absolute -top-6 right-0 hidden font-display text-[9rem] font-bold leading-none text-outline-dark lg:block" aria-hidden="true">
          30
        </div>
      </div>
    </div>
  </section>
);
